var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ym-button',{staticClass:"header-back-btn-component",style:(_vm.buttonStyle),attrs:{"icon":"back"},on:{"click":_vm.handleClickBack}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }